<template>
    <div class="_label">
        <i class="fas fa-copy text-info" @click="copyToClipboard(val)" @mouseout="out">
            <span class="tooltiptext" :id="id">{{ trans[locale].copy }}</span>
        </i>
    </div>
</template>

<script>
export default {
    name: "CopyToClipBoard",
    props: {
        val: {
            type: String,
            required: true,
        }
    },
    data(){
        return {
            locale: window.locale,
            id: this.makeId(),
            trans:{
                en:{
                    copy: 'Copy',
                    copied: 'Copied to clipboard',
                },
                'zh-HK':{
                    copy: '複製',
                    copied: '已複製到剪貼簿',
                },
            }
        }
    },
    methods: {
        makeId() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

            for (var i = 0; i < 10; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        },
        copyToClipboard(value) {
            let tempInput = document.createElement("input");
            tempInput.value = value;
            document.body.appendChild(tempInput);
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); /*For mobile devices*/
            document.execCommand("copy");
            document.body.removeChild(tempInput);

            let tooltip = document.getElementById(this.id);
            tooltip.innerHTML = this.trans[locale].copied;
        },
        out() {
            let tooltip = document.getElementById(this.id);
            tooltip.innerHTML = this.trans[locale].copy;
        },
    }
}
</script>

<style scoped>
._label {
    position: relative;
    display: inline-block;
}

._label .tooltiptext {
    visibility: hidden;
    width: 140px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 150%;
    left: 50%;
    margin-left: -75px;
    opacity: 0;
    transition: opacity 0.3s;
}

._label .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

._label:hover .tooltiptext {
    visibility: visible;
    cursor: pointer;
    opacity: 1;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Copy/CopyToClipBoard.vue